

























































































import { Component, Vue } from "vue-property-decorator";
import { listLog } from "@/api/system/log";
import { getDicts } from "@/api/system/data";
import { addDateRange, selectDictLabel } from "@/utils/comparsion";
import { dateFormat } from "@/utils/utils";
@Component({})
export default class Log extends Vue {
  public queryParams = {
    pageNum: 1,
    pageSize: 10,
    operName: undefined,
    businessType: undefined,
    status: undefined
  };
  public item = [];
  public dateRange = [];
  public total = 0;
  public typeOptions = [];
  public list = [];
  public statusOptions = [];
  public loading = false;
  public created() {
    this.getList();
    // 获取操作类型
    getDicts("sys_oper_type").then(response => {
      this.typeOptions = response.data;
    });
    // 获取操作状态
    getDicts("sys_common_status").then(response => {
      this.statusOptions = response.data;
    });
  }
  // 查询表格数据
  public onSubmit() {
    this.queryParams.pageNum = 1;
    this.getList();
  }
  /** 查询登录日志 */
  public getList() {
    this.loading = true;
    listLog(addDateRange(this.queryParams, this.dateRange)).then(response => {
      this.list = response.rows;
      this.total = response.total;
      this.loading = false;
    });
  }
  // 操作日志状态字典翻译
  public statusFormat(row, column) {
    return selectDictLabel(this.statusOptions, row.status);
  }
  // 操作日志类型字典翻译
  public typeFormat(row, column) {
    return selectDictLabel(this.typeOptions, row.businessType);
  }
}
